import React, { useState } from 'react';
import styles from './Login.module.css';
import { Button } from '../../components/common/Button/Button';

const omgevingsCompasLogo = '/assets/logos/OmgevingsCompas_logo.svg';

interface LoginProps {
  onLogin: (email: string, password: string) => void;
  onLinkedInLogin?: () => void;
}

export const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('onno.dejager@constructa.nl');
  const [password, setPassword] = useState('password');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(email, password);
  };

  return (
    <div className={styles.loginScreen}>
      {/* Left side - Login form */}
      <div className={styles.loginLeft}>
        <div className={styles.loginBox}>
          <img src={omgevingsCompasLogo} alt="OmgevingsCompas" className={styles.loginLogo} />
          <p className={styles.loginSubtitle}>Log in om door te gaan naar uw projectomgeving</p>

          <form className={styles.loginForm} onSubmit={handleSubmit}>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>E-mailadres</label>
              <input
                type="text"
                className={styles.inputField}
                placeholder="naam@organisatie.nl"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Wachtwoord</label>
              <input
                type="password"
                className={styles.inputField}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className={styles.formOptions}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className={styles.checkbox}
                />
                Onthoud mij
              </label>
              <a href="#forgot" className={styles.forgotLink} onClick={(e) => e.preventDefault()}>
                Wachtwoord vergeten?
              </a>
            </div>

            <Button type="submit" variant="primary" size="large" fullWidth>
              Inloggen
            </Button>

            <p className={styles.contactText}>
              Nog geen account? <a href="#contact" className={styles.contactLink} onClick={(e) => e.preventDefault()}>Neem contact op</a>
            </p>
          </form>
        </div>
      </div>

      {/* Right side - Marketing panel */}
      <div className={styles.loginRight}>
        <div className={styles.rightContent}>
          <h1 className={styles.rightTitle}>
            Leene Communicatie introduceert OmgevingsCompas: de slimme AI-tool voor participatie en communicatie.
          </h1>
          <ul className={styles.featureList}>
            <li className={styles.featureItem}>
              <span className={styles.featureCheck}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              Direct inzicht in sentimenten en doelgroepen
            </li>
            <li className={styles.featureItem}>
              <span className={styles.featureCheck}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              Centrale verzameling van Q&A's van belanghebbenden
            </li>
            <li className={styles.featureItem}>
              <span className={styles.featureCheck}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              Helpt bij strategische keuzes in participatie en communicatie
            </li>
            <li className={styles.featureItem}>
              <span className={styles.featureCheck}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
              Ontwikkelt de basis voor bewonersbrieven, posters en andere middelen
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
